import { useEffect } from 'react';
import { useCMS } from '../../context/CMSContext';
import { initGoogleTracking } from '../../lib/googleTracking';

/**
 * Google 廣告追蹤掛載點（無畫面）：
 * CMS 設定載入後，依 siteConfig.googleTracking 注入 GTM/gtag。
 */
export const GoogleTracking: React.FC = () => {
  const { cmsData } = useCMS();

  useEffect(() => {
    initGoogleTracking(cmsData.siteConfig.googleTracking);
  }, [cmsData.siteConfig.googleTracking]);

  return null;
};
